import React from 'react'
import { Link } from "react-router-dom";


const Accreditations = () => {
    return (
        <>

            <div className="our-core-feature light-section" style={{marginTop:"-50px"}}>
                <div className="container">
                    <div className="row section-row align-items-center">
                        <div className="col-xl-12">
                            {/* Section Title Start */}
                            <div className="section-title" style={{marginTop:"-40px"}}>
                                <span className="section-sub-title wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Our Core Features</span>
                                <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="Innovative solar feature with real environmental impact" style={{ perspective: 400 }}>
                                    <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                                            India's Largest Growing Solar Company
                                        </div>
                                    </div>
                                </h2>
                            </div>
                            {/* Section Title End */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-4 order-xl-1 order-2">
                            {/* Core Feature Image Start */}
                            <div className="core-feature-image">
                                <figure>
                                    <img src="./assets/images/our-core-feature-image.png" alt />
                                </figure>
                            </div>
                            {/* Core Feature Image End */}
                        </div>
                        <div className="col-xl-8 order-xl-2 order-1">
                            {/* Core Feature Item List Start */}
                            <div className="core-feature-item-list">
                                {/* Core Feature Item Start */}
                                <div className="core-feature-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="core-feature-item-header">
                                        <div className="icon-box">
                                            <img src="./assets/images/icon-core-feature-1.svg" alt />
                                        </div>
                                        <div className="core-feature-item-number">
                                            <h3>01.</h3>
                                        </div>
                                    </div>
                                    <div className="core-feature-item-content">
                                        <h3>Expert Installation and Service</h3>
                                        <p>Our experienced team guarantees you a safe, fast, and professional solar installation</p>
                                    </div>
                                </div>
                                {/* Core Feature Item End */}
                                {/* Core Feature Item Start */}
                                <div className="core-feature-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                    <div className="core-feature-item-header">
                                        <div className="icon-box">
                                            <img src="./assets/images/icon-core-feature-2.svg" alt />
                                        </div>
                                        <div className="core-feature-item-number">
                                            <h3>02.</h3>
                                        </div>
                                    </div>
                                    <div className="core-feature-item-content">
                                        <h3>High-Quality Products</h3>
                                        <p>We use only certified and reliable solar panels and equipment, ensuring superior, long-term performance for you.</p>
                                    </div>
                                </div>
                                {/* Core Feature Item End */}
                                {/* Core Feature Item Start */}
                                <div className="core-feature-item wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                    <div className="core-feature-item-header">
                                        <div className="icon-box">
                                            <img src="./assets/images/icon-core-feature-3.svg" alt />
                                        </div>
                                        <div className="core-feature-item-number">
                                            <h3>03.</h3>
                                        </div>
                                    </div>
                                    <div className="core-feature-item-content">
                                        <h3>Cost-Effective Solutions</h3>
                                        <p>Greater savings at a lower cost! Our solar systems lead to a significant reduction in your electricity bills</p>
                                    </div>
                                </div>
                                {/* Core Feature Item End */}
                                {/* Core Feature Item Start */}
                                <div className="core-feature-item wow fadeInUp" data-wow-delay="0.6s" style={{ visibility: 'visible', animationDelay: '0.6s', animationName: 'fadeInUp' }}>
                                    <div className="core-feature-item-header">
                                        <div className="icon-box">
                                            <img src="./assets/images/icon-core-feature-4.svg" alt />
                                        </div>
                                        <div className="core-feature-item-number">
                                            <h3>04.</h3>
                                        </div>
                                    </div>
                                    <div className="core-feature-item-content">
                                        <h3>Trust & Warrenty 24*7 Support</h3>
                                        <p>High Quality Work Cost-effective solutions</p>
                                    </div>
                                </div>
                                {/* Core Feature Item End */}
                            </div>
                            {/* Core Feature Item List End */}
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default Accreditations